/* eslint-disable no-console */

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log("Приложение обслуживается из кэша Service Worker");
    },
    registered() {
      console.log("Service Worker зарегистрирован");
    },
    cached() {
      console.log("Контент кэширован для офлайн использования");
    },
    updatefound() {
      console.log("Загружается новый контент");
    },
    updated(registration) {
      console.log("Новый контент доступен; обновите страницу");

      if (registration && registration.waiting) {
        const updateSW = () => {
          if (registration.waiting) {
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
          }
        };

        const refreshApp = () => {
          if (registration.waiting) {
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
            window.location.reload();
          }
        };

        if (confirm("Доступна новая версия приложения. Обновить сейчас?")) {
          refreshApp();
        }
      }
    },
    offline() {
      console.log(
        "Нет подключения к интернету. Приложение работает в офлайн режиме"
      );
    },
    error(error) {
      console.error("Ошибка при регистрации Service Worker:", error);
    },
  });
}

const showInstallPromotion = () => {
  let deferredPrompt: any;

  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;

    const installButton = document.createElement("button");
    installButton.textContent = "Установить приложение";
    installButton.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: #007bff;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 8px;
      cursor: pointer;
      z-index: 1000;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    `;

    installButton.addEventListener("click", async () => {
      if (deferredPrompt) {
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;

        if (outcome === "accepted") {
          console.log("Пользователь установил PWA");
        } else {
          console.log("Пользователь отклонил установку PWA");
        }

        deferredPrompt = null;
        installButton.remove();
      }
    });

    document.body.appendChild(installButton);
  });

  window.addEventListener("appinstalled", () => {
    console.log("PWA успешно установлено");
    deferredPrompt = null;
  });
};

if (process.env.NODE_ENV === "production") {
  showInstallPromotion();
}
